/**
 * Pure walks over the topics the tree endpoint returns. Kept out of the
 * components so the selection arithmetic can be tested without a DOM.
 */
import type { TreeTopic } from "../api/domain.ts";

/** The ids of a topic's questions, which is what a selection is made of. */
export const topicQuestionIds = (topic: TreeTopic): string[] =>
  topic.questions.map((question) => question.id);

/** Every question of every topic, in catalog order. */
export const allQuestionIds = (topics: readonly TreeTopic[]): string[] =>
  topics.flatMap(topicQuestionIds);

/** Every question the topics already place, which is what "assigned" means. */
export const assignedQuestionIds = (topics: readonly TreeTopic[]): ReadonlySet<string> =>
  new Set(allQuestionIds(topics));
